<div>
    <mat-card *ngFor="let img of imagenes">
        <mat-card-title>
            <span>{{img.titulo}}</span>  
        </mat-card-title>
       
        <img [src]=img.imagen>
        <mat-card-footer>
           <p>Por {{img.creador}}</p>   
        </mat-card-footer>
        
    </mat-card>
</div>